import React from "react";
import { Modal, Button } from "antd";
import { FileExcelOutlined } from "@ant-design/icons";
import "./ExportConfirmationModal.scss";

interface ExportConfirmationModalProps {
  open: boolean;
  onCancel: () => void;
  onCombine: () => void;
  onSeparate: () => void;
  selectedCount: number;
}

const ExportConfirmationModal: React.FC<ExportConfirmationModalProps> = ({
  open,
  onCancel,
  onCombine,
  onSeparate,
  selectedCount,
}) => {
  return (
    <Modal
      open={open}
      footer={null}
      closable
      onCancel={onCancel}
      centered
      className="export-confirmation-modal" >
      <div className="confirmation-modal-wrapper ">
        <div className="confirmation-modal-header">
          <img src="/images/folder-input.svg" className="confirmation-Icon" alt="Modal Icon" />
          <label className="popup-msg-content">Confirm Export</label>
        </div>
<div className="confirmation-modal-body">
  <span>
    {`You’ve selected ${selectedCount} list${selectedCount > 1 ? "s" : ""}. How would you like to export them?`}
  </span>
</div>

        <div className="confirmation-modal-footer">
          <Button
            type="primary"
            danger
            className="red-btn"
            onClick={onCombine}
          >
            Combine
          </Button>
          <Button className="grey-btn" onClick={onSeparate}>
            Separately
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ExportConfirmationModal;
